import Vue from 'vue';
import { Component, Ref } from 'vue-property-decorator';

import DestinationCard from '@/common/interfaces/modules/DestinationCard';
import { ImageWidths, ImageSizes, ImageSize } from '@/common/interfaces/SizeBreakpoints';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';

const DestinationCardComponentProps = Vue.extend({
  props: { card: Object as () => DestinationCard },
});

@Component({
  components: {
    ResponsiveImageRatio,
  },
})
export default class DestinationCardComponent extends DestinationCardComponentProps {
  ratioPortrait: string = '2x3';
  ratioLandscape: string = '3x2';

  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  get ratio() {
    return this.card.IsLong ? this.ratioPortrait : this.ratioLandscape;
  }
}
